// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';

// export const apiUrl = 'http://192.168.1.202:8000/apis/';
// export const assetsUrl = 'https://blisstainment.com/apibackend/assets/';

export const apiUrl = 'https://blisstainment.com/apibackend/apis/';
export const assetsUrl = 'https://blisstainment.com/apibackend/assets/';